import { Space } from 'antd-mobile';
import { MailOpenOutline, MovieOutline, SetOutline, StarOutline, UserOutline } from 'antd-mobile-icons';
import { useThrottledHandler } from 'App';
import { useI18n } from 'i18n/useI18n';
import '/';

export type UserOptType = {
  userPageIndex: any;
  setUserPageIndex: (activePanelIndex: number) => void;
};

export type OptDataType = {
  index: number;
  title: string;
  icon: any;
};

const UserOptBar: React.FC<UserOptType> = (props) => {
  const { t } = useI18n();
  const optListData: OptDataType[] = [
    {
      index: 0,
      title: t('user-opt-bar.index.180777-0'),
      icon: <UserOutline fontSize={26} />,
    },
    {
      index: 1,
      title: t('user-opt-bar.index.180777-2'),
      icon: <StarOutline fontSize={26} />,
    },
    {
      index: 2,
      title: t('user-opt-bar.index.180777-3'),
      icon: <MovieOutline fontSize={26} />,
    },
    {
      index: 3,
      title: t('user-opt-bar.index.180777-4'),
      icon: <MailOpenOutline fontSize={26} />,
    },
    {
      index: 4,
      title: t('user-opt-bar.index.180777-1'),
      icon: <SetOutline fontSize={26} />,
    },
  ];

  return (
    <>
      <div className=" w-full flex justify-between items-center gap-2">
        {optListData.map((item, index) => {
          return (
            <div
              key={index}
              style={{
                color: props.userPageIndex === item.index ? '#f33' : '#333',
              }}
              className={
                ' grow flex flex-col items-center justify-center font-bold shadow-md rounded-md bg-gradient-to-br from-white/80 to-white/30 p-2 '
              }
              onClick={() => {
                props.setUserPageIndex(item.index);
              }}
            >
              <div>{item.icon}</div>
              <div className=" text-xs my-1 text-nowrap">{item.title}</div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default UserOptBar;
